module.exports = __webpack_public_path__ + "images/notifications/calendar@2x-bb88585ad42d439c2788d8045df0ad0c.png";